import _ from 'lodash';
import moment from 'moment';

import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles/index';
import pfLogo from '../images/pearsonFuelsLogoV2.png';
import PhoneIcon from '@material-ui/icons/Phone';
import EmailIcon from '@material-ui/icons/Email';
import LangIcon from '@material-ui/icons/Language';

const styles = () => {
	const p = (v) => {
		return `${v * 100}%`;
	};
	const pBlue = '#2B547B';
	const lineColor = '#D9D9D9';

	return {
		root: {
			position: 'relative',
			height: '100%',
			width: '100%',
			padding: `${p(0.065)} ${p(0.075)}`,
			boxSizing: 'border-box',
			fontFamily: 'Roboto',
			color: '#666',
			fontSize: '1.8vw',
		},
		rootWrapper: {
			position: 'relative',
			height: '100%',
			width: '100%',
			//border : '1px solid red',
		},
		logo: {
			marginTop: p(0.02),
			width: p(0.52),
			//height : p(0.),
		},
		bigInvoiceContainer: {
			marginTop: '7%',
			borderTop: `1px solid ${lineColor}`,
			borderBottom: `1px solid ${lineColor}`,
			display: 'flex',
			flexDirection: 'row',
			justifyContent: 'space-between',
			alignItems: 'center',
			padding: '1% 0%',
		},
		bigInvoice: {
			fontSize: '6.2vw',
			fontWeight: 100,
			color: pBlue,
			flexBasis: '33%',
			textAlign: 'left',
		},
		billingInfo: {
			textAlign: 'left',
			marginRight: '3%',
			flexBasis: '33%',
		},
		deliveredTo: {
			textAlign: 'left',
			marginRight: '1%',
			flexBasis: '33%',
		},
		label: {
			fontWeight: 600,
			color: '#111',
			letterSpacing: '.1em',
		},
		poInfo: {
			marginTop: '5%',
			display: 'flex',
			flexDirection: 'row',
			justifyContent: 'space-between',
			alignItems: 'center',
			textAlign: 'left',
		},
		poGroup: {
			flexGrow: 1,
			marginRight: '6%',
			'&:last-child': {
				marginRight: '0%',
			},
		},
		poLabel: {
			fontWeight: 600,
			color: '#111',
			letterSpacing: '.1em',
			borderBottom: `1px solid ${lineColor}`,
			paddingBottom: '.4vw',
			textTransform: 'uppercase',
			marginBottom: '.5vw',
		},

		itemSection: {
			marginTop: '7%',
		},
		labelLine: {
			display: 'flex',
			flexDirection: 'row',
			justifyContent: 'space-between',
			alignItems: 'center',
			textAlign: 'left',
			borderBottom: `1px solid ${lineColor}`,
			paddingBottom: '.4vw',
			fontWeight: 600,
			color: '#111',
			letterSpacing: '.1em',
			textTransform: 'uppercase',
		},
		colDescription: {
			flexBasis: '40%',
			textAlign: 'left',
		},
		colQuantity: {
			flexBasis: '20%',
			textAlign: 'right',
		},
		colUnitCost: {
			flexBasis: '20%',
			textAlign: 'right',
		},
		colSubTotal: {
			flexBasis: '20%',
			textAlign: 'right',
		},
		itemRow: {
			display: 'flex',
			flexDirection: 'row',
			justifyContent: 'space-between',
			alignItems: 'center',
			textAlign: 'left',
			borderBottom: `1px solid ${lineColor}`,
			paddingTop: '.9vw',
			paddingBottom: '.9vw',
			//letterSpacing : '.1em',
		},
		miniTotalSection: {
			marginTop: '4%',
			display: 'flex',
			flexDirection: 'row',
			textAlign: 'right',
			justifyContent: 'flex-end',
		},
		termsSection: {
			marginTop: '6%',
		},
		termTitle: {},
		termAndTotal: {
			display: 'flex',
			flexDirection: 'row',
			justifyContent: 'space-between',
			marginTop: '.8%',
		},
		termParagraph: {
			fontSize: '92%',
			color: '#999999',
			textAlign: 'left',
			fontWeight: 200,
			flexBasis: '55%',
		},
		bigTotal: {
			fontSize: '6.2vw',
			fontWeight: 100,
			color: pBlue,
			textAlign: 'right',
		},
		bottomSection: {
			position: 'absolute',
			bottom: '0%',
			width: '100%',
			marginBottom: '1%',
		},
		anyIssues: {
			borderBottom: `1px solid ${lineColor}`,
			fontWeight: 600,
			marginBottom: '.8%',
			paddingBottom: '.8%',
			fontSize: '110%',
			textAlign: 'left',
		},
		contactSection: {
			display: 'flex',
			justifyContent: 'space-between',
			alignItems: 'center',
			justifyItems: 'center',
			textAlign: 'left',
			lineHeight: 1.2,
		},
		phoneEmail: {},
		thankYou: {
			fontSize: '4.8vw',
			fontWeight: 100,
			color: pBlue,
			textAlign: 'right',
		},
		contactIcon: {
			fontSize: '1.8vw',
			marginRight: 5,
		},
		contactLine: {
			display: 'flex',
			alignItems: 'center',
		},
	};
};

class TrueUpInvoiceForPdf extends Component {
	/*
	constructor (props) {
		super(props);
		this.state = {

		};
	}
	*/

	render() {
		const {
			classes,
			trueUpInvoice,
			bulkCustomerMap,
			quickbooksCustomerMap,
			quickbooksTermMap,
		} = this.props;

		if (!trueUpInvoice) {
			return <div>Fetching trueUp invoice...</div>;
		}

		const {
			trueUpInvoiceId,
			//productType,
			bulkCustomerId,
			quickbooksTermId,
			issueDate,
			lineItems,

			trueUpForMonth,
			trueUpForYear,
			isCredit,
		} = trueUpInvoice;

		const bulkCustomer = bulkCustomerMap[bulkCustomerId] || { name: 'Missing bulk customer' };
		const { invoiceQuickbooksCustomerId } = bulkCustomer;
		const quickbooksCustomer = quickbooksCustomerMap[invoiceQuickbooksCustomerId];

		let billingAddress = 'Missing quickbooks customer';

		if (quickbooksCustomer) {
			let { BillAddr, PrintOnCheckName } = quickbooksCustomer;

			/** @namespace BillAddr.Line1 **/
			/** @namespace BillAddr.Line2 **/
			/** @namespace BillAddr.City **/
			/** @namespace BillAddr.CountrySubDivisionCode **/
			/** @namespace BillAddr.PostalCode **/
			/** @namespace ShipAddr.Line1 **/
			/** @namespace ShipAddr.Line2 **/
			/** @namespace ShipAddr.City **/
			/** @namespace ShipAddr.CountrySubDivisionCode **/
			/** @namespace ShipAddr.PostalCode **/

			if (!BillAddr) {
				BillAddr = {};
			}

			billingAddress = (
				<Fragment>
					{PrintOnCheckName}
					<br />
					{BillAddr.Line1}
					<br />
					{!!BillAddr.Line2 && (
						<Fragment>
							{BillAddr.Line2}
							<br />
						</Fragment>
					)}
					{BillAddr.City}, {BillAddr.CountrySubDivisionCode} {BillAddr.PostalCode}
				</Fragment>
			);
		}

		const quickbooksTerm = quickbooksTermMap[quickbooksTermId] || { Name: '🚨 MISSING TERMS' };

		const issueMoment = moment(issueDate);
		let dueDate = 'Need terms';

		/** @namespace quickbooksTerm.DueDays **/
		if (quickbooksTerm.DueDays) {
			dueDate = moment(issueMoment).add(quickbooksTerm.DueDays, 'days').format('M/D/YY');
		}

		/*
		"BillAddr": {
			"Id": "96",
				"Line1": "10743 Juniper Park Lane",
				"City": "San Diego",
				"Country": "US",
				"CountrySubDivisionCode": "CA",
				"PostalCode": "92121"
		},
		"ShipAddr": {
			"Id": "97",
				"Line1": "514 Via De La Valle",
				"City": "Solana Beach",
				"Country": "US",
				"CountrySubDivisionCode": "CA",
				"PostalCode": "92176"
		},
		*/

		let total = 0;
		let title, billTo, amountDue;

		if (isCredit) {
			title = 'CREDIT';
			billTo = 'CREDIT TO';
			amountDue = 'Total Credit';
		} else {
			title = 'INVOICE';
			billTo = 'BILL TO';
			amountDue = 'Amount Due';
		}

		// Create our number formatter.
		const moneyFormatter = new Intl.NumberFormat('en-US', {
			style: 'currency',
			currency: 'USD',
			minimumFractionDigits: 2,
			// the default value for minimumFractionDigits depends on the currency
			// and is usually already 2
		});

		const m = moment().month(trueUpForMonth).format('MMMM');
		const period = `${m}, ${trueUpForYear}`;

		return (
			<div className={classes.root}>
				<div className={classes.rootWrapper}>
					<img alt="Logo" className={classes.logo} src={pfLogo} />
					<div className={classes.bigInvoiceContainer}>
						<div className={classes.bigInvoice}>{title}</div>
						<div className={classes.billingInfo}>
							<div className={classes.label}>{billTo}</div>
							<div>{billingAddress}</div>
						</div>
						<div className={classes.deliveredTo}>
							<div className={classes.label}>TRUE UP</div>
							<div>
								End of month
								<br />
								for {period}
								<br />
								<br />
							</div>
						</div>
					</div>

					<div className={classes.poInfo}>
						<div className={classes.poGroup}>
							<div className={classes.poLabel}>Invoice #</div>
							<div>{trueUpInvoiceId}</div>
						</div>

						{!isCredit && (
							<div className={classes.poGroup}>
								<div className={classes.poLabel}>Terms</div>
								<div>{quickbooksTerm.Name}</div>
							</div>
						)}

						<div className={classes.poGroup}>
							<div className={classes.poLabel}>Date Issued</div>
							<div>{issueMoment.format('M/D/YY')}</div>
						</div>

						{!isCredit && (
							<div className={classes.poGroup}>
								<div className={classes.poLabel}>Date Due</div>
								<div>{dueDate}</div>
							</div>
						)}
					</div>

					<div className={classes.itemSection}>
						<div className={classes.labelLine}>
							<div className={classes.colDescription}>DESCRIPTION</div>
							<div className={classes.colQuantity}>QUANTITY</div>
							<div className={classes.colUnitCost}>UNIT COST</div>
							<div className={classes.colSubTotal}>SUBTOTAL</div>
						</div>

						{lineItems.map((lineItem, i) => {
							const { Description, Qty, UnitPrice, Amount } = lineItem;
							total += Amount;

							return (
								<div key={i} className={classes.itemRow}>
									<div className={classes.colDescription}>{Description}</div>
									<div className={classes.colQuantity}>{Qty}</div>
									<div className={classes.colUnitCost}>{UnitPrice}</div>
									<div className={classes.colSubTotal}>{moneyFormatter.format(Amount)}</div>
								</div>
							);
						})}
					</div>

					<div className={classes.miniTotalSection}>
						<div className={classes.poGroup} style={{ flexGrow: 'unset', width: '15%' }}>
							<div className={classes.poLabel}>Total</div>
							<div>{moneyFormatter.format(total)}</div>
						</div>
					</div>

					<div className={classes.termsSection}>
						<div className={classes.labelLine}>
							<div>Terms &amp; Conditions</div>
							<div>{amountDue}</div>
						</div>
						<div className={classes.termAndTotal}>
							<div className={classes.termParagraph}>
								E85 contains no more than 85% ethanol.
								<br />
								LCFS obligations retained by seller.
								<br />
								<br />
								This volume of neat or blended Ethanol, Bio Diesel and or Renewable Diesel is
								designated and intended for use as transportation fuel or jet fuel in the 48 U.S.
								contiguous states and Hawaii. Any person exporting this fuel is subject to the
								requirements of 40 CFR 80.1430
								<br />
								<br />
								Denatured fuel, maximum 10 ppm sulfur.
							</div>
							<div className={classes.bigTotal}>{moneyFormatter.format(total)}</div>
						</div>
					</div>

					<div className={classes.bottomSection}>
						<div className={classes.anyIssues}>
							If there are any issues with this invoice please contact us immediately.
						</div>

						<div className={classes.contactSection}>
							<div className={classes.address}>
								Pearson Fuels
								<br />
								1360 Rosecrans St, Suite A<br />
								San Diego, CA 92106
								<br />
							</div>

							<div className={classes.phoneEmail}>
								<div className={classes.contactLine}>
									<PhoneIcon className={classes.contactIcon} /> 619.521.2411
								</div>
								<div className={classes.contactLine}>
									<EmailIcon className={classes.contactIcon} /> accounting@pearsonfuels.com
								</div>
								<div className={classes.contactLine}>
									<LangIcon className={classes.contactIcon} /> pearsonfuels.com
								</div>
							</div>
							<div className={classes.thankYou}>THANK YOU!</div>
						</div>
					</div>
				</div>
			</div>
		);
	}
}

TrueUpInvoiceForPdf.propTypes = {
	classes: PropTypes.object,
	authUser: PropTypes.object,
	trueUpInvoice: PropTypes.object.isRequired,
	quickbooksCustomerMap: PropTypes.object,
	quickbooksTermMap: PropTypes.object.isRequired,
	bulkCustomerMap: PropTypes.object,
};

export default _.flow([withStyles(styles)])(TrueUpInvoiceForPdf);
